// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
// import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors"; // Starter Custom Code
import {
    chain,
    LoadRealTimePrices,
    ParseQueryParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
// import { ProductModel, } from "@insite/client-framework/Types/ApiModels"; // Starter Custom Code
import { dispatchProductImpressions } from "@store/Framework/Services/AnalyticsService";

// Starter Custom Code - >
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel, RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
// <--- Starter Custom Code

// Bunzl code -->
import { getCookie } from "@insite/client-framework/Common/Cookies";
import qs from "qs";
// <-- Bunzl code

const enum pageType {
    productListPage = "Product List Page",
    searchPage = "Search Page",
}

replaceInChain(chain, LoadRealTimePrices, async props => {
    const {
        result: { productInfosByProductId },
    } = props;
    const productIds = Object.keys(productInfosByProductId);
    if (productIds.length === 0) {
        return;
    }
    const state = props.getState();
    const { isSearch } = props.parameter;
    const currency = state.context.session.currency?.currencyCode;
    const page = isSearch ? pageType.searchPage : pageType.productListPage;
    // Starter Custom Code - >
    const session = getSession(state);
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;

    const handleProductsImpressions = (realTimePricing?: RealTimePricingModel) => {
        const products = props.result.products?.map(product => {
            return {
                ...product,
                unitListPrice: realTimePricing?.realTimePricingResults?.find(p => p.productId === product.id)
                    ?.unitListPrice,
            };
        });
        dispatchProductImpressions(products as ProductModel[], currency, page);
    };

    if (!isAuthenticated) {
        handleProductsImpressions();
    }
    // <--- Starter Custom Code

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: productIds.map(o => productInfosByProductId[o]!),
            onSuccess: realTimePricing => {
                // Starter Custom Code - >
                if (isAuthenticated) {
                    handleProductsImpressions(realTimePricing);
                }
                // <-- Starter Custom Code
                props.dispatch({
                    type: "Pages/ProductList/CompleteLoadRealTimePricing",
                    realTimePricing,
                });
                props.pricingLoaded = true;
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductList/FailedLoadRealTimePricing",
                });
                props.pricingLoaded = true;
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );

    if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
        await waitFor(() => !!props.pricingLoaded);
    }
});

replaceInChain(chain, ParseQueryParameter, props => {
    const { queryString } = props.parameter;
    const parsedQuery = qs.parse(queryString.startsWith("?") ? queryString.substr(1) : queryString) as any; // Bunzl code - Optimizely is typing as any so we're doing this instead of messing with base types
    const splitCommaSeparated = (value?: string | string[] | null) =>
        typeof value === "string" ? value.split(",") : undefined;
    const {
        query,
        page,
        sort,
        includeSuggestions,
        stockedItemsOnly,
        // Bunzl code -->
        inStockRealTime,
        // <-- Bunzl code
        previouslyPurchasedProducts,
        categoryId,
        brandIds,
        productLineIds,
        priceFilters,
        attributeValueIds,
        searchWithinQueries,
    } = parsedQuery;

    let pageSize = parsedQuery.pageSize;

    if (!pageSize) {
        pageSize = getCookie("ProductList-PageSize");
    }

    const { catalogPage } = props.result;

    props.result.productFilters = {
        query,
        page: page ? parseInt(page as string, 10) : undefined,
        pageSize: pageSize ? parseInt(pageSize as string, 10) : undefined,
        sort,
        includeSuggestions: includeSuggestions !== undefined ? includeSuggestions === "true" : undefined,
        stockedItemsOnly: stockedItemsOnly !== undefined ? stockedItemsOnly === "true" : undefined,
        // Bunzl code -->
        inStockRealTime: inStockRealTime !== undefined ? inStockRealTime === "true" : undefined,
        // <-- Bunzl code
        previouslyPurchasedProducts:
            previouslyPurchasedProducts !== undefined ? previouslyPurchasedProducts === "true" : undefined,
        pageCategoryId: catalogPage?.categoryId,
        pageBrandId: catalogPage?.brandId || undefined,
        pageProductLineId: catalogPage?.productLineId || undefined,
        categoryId,
        brandIds: splitCommaSeparated(brandIds),
        productLineIds: splitCommaSeparated(productLineIds),
        priceFilters: splitCommaSeparated(priceFilters),
        attributeValueIds: splitCommaSeparated(attributeValueIds),
        searchWithinQueries: splitCommaSeparated(searchWithinQueries),
    };
});
